module.exports = __webpack_public_path__ + "media/components/t-shirt-comp/static/La-Cicer-b182924db52c250b822b2403ca3b24d5.jpg";